import { memo } from 'react';
import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getPlanPageThemeColors } from 'redux/ThemeSlice';

import RevampInputSection from './RevampInputSection';

import type { PlanPageRefetchRequest } from '../planPageFetchHelpers';

interface Properties {
  refetchRequest: PlanPageRefetchRequest;
}

const DriverInputPanel = ({ refetchRequest }: Properties) => {
  const themeColors = useSelector(getPlanPageThemeColors);

  return (
    <Box
      h='100%'
      flex='1'
      minW={0}
      bg={themeColors.surface}
      borderRight='1px solid'
      borderColor={themeColors.border}
      overflow='hidden'
      display='flex'
      flexDirection='column'
    >
      <RevampInputSection refetchRequest={refetchRequest} />
    </Box>
  );
};

export default memo(DriverInputPanel);
